import React from 'react';
import { Helmet } from 'react-helmet'
import './project-support.css';

function ProjectSupport() {
    return (
        <>
            {/* Helmet for SEO */}
            <Helmet>
                <title>Project Support Services | ERA Automation & Software</title>

                <meta
                    name="description"
                    content="ERA Automation & Software provides skilled manpower and project support for businesses in need of expert resources. Our dedicated team helps you manage, execute, and complete your projects efficiently."
                />


                <meta
                    name="keywords"
                    content="project support services, skilled manpower for projects, temporary project staffing, IT project resources, project execution support, 
                    on-demand project support, project management support, business project staffing, project assistance, professional project resources"
                />
            </Helmet>
            <div>


                <div className='w-screen h-screen justify-center items-center flex'>
                    <div className='w-1/2 -mt-32 banner '>
                        <h1 style={{ wordSpacing: '0.2em', lineHeight: '1.4' }}  className="text-7xl  uppercase  font-bold text-center font-italiana lg:text-7xl md:text-5xl sm:text-4xl md:leading-relaxed sm:leading-relaxed">
                            strong hands to 
                            <span style={{ wordSpacing: '0.3em', lineHeight: '1.4' }}  className='font-sans  lg:text-7xl md:text-5xl sm:text-4xl'> lift </span> your  
                            <span style={{ wordSpacing: '0.3em', lineHeight: '1.4' }}  className='font-sans lg:text-7xl md:text-5xl sm:text-4xl'> projects higher</span>
                        </h1>
                    </div>

                </div>



                <div className='h-full w-screen project-support-description'>
                    <div className="flex items-center justify-center ">
                        <div className="p-5 text-center w-1/2 width">
                            <h1 className="capitalize font-bold text-4xl h1Tag">Project Support Services: Helping You Succeed</h1>
                            <p className="text-xl leading-normal text-wrap py-6 pTag ">
                                We know how challenging it can be to keep your projects on track. Whether your deadlines are fast approaching
                                or you need skilled manpower to ensure success, we are here to help you every step of the way.
                            </p>
                        </div>
                    </div>


                    

                    <div className="flex items-center justify-center py-20">
                        <div className="p-5 text-center w-1/2 width">
                            <h1 className='capitalize  font-bold text-4xl h1Tag'>What We Offer</h1>
                            <ul className='text-xl leading-normal  py-6 list-disc pTag '>
                                <li className='py-4'><span className='font-bold spanTag '>Manpower Solutions:</span> Our skilled professionals are ready to step in and support your team to keep your projects on schedule.</li>
                                <li className='py-4'><span className='font-bold spanTag '>Tailored Project Assistance:</span> From planning and strategy to hands-on execution, we adapt our services to meet your unique needs.</li>
                                <li className='py-4'><span className='font-bold spanTag '>Deadline-Driven Support: </span>Facing tight timelines? Count on us to provide reliable, fast, and efficient support when it matters most.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="flex items-center justify-center py-20">
                        <div className="p-5 text-center w-1/2 width">
                            <h1 className='capitalize  font-bold text-4xl h1Tag'>Why Choose Us?</h1>
                            <ul className='text-xl leading-normal text-wrap py-6 pTag '>
                                <li className='py-4'><span className='font-bold spanTag '>Experienced Team: </span> Our experts have years of experience in software development, app development, and project management.</li>
                                <li className='py-4'><span className='font-bold spanTag '>Quick Response: </span> When time is of the essence, we ensure seamless integration with your team to meet your goals.</li>
                                <li className='py-4'><span className='font-bold spanTag '>Cost-Effective Solutions: </span>Gain access to professional expertise without the long-term costs of hiring full-time staff.</li>
                            </ul>
                        </div>
                    </div>


                    <div className="flex items-center justify-center py-20">
                        <div className="p-5 text-center w-1/2 width">
                            <h1 className='capitalize  font-bold text-4xl h1Tag'>Is Your Deadline Near? We’ve Got You Covered!</h1>
                            <p className='text-xl leading-normal text-wrap py-6 pTag '>Time running out? Don’t worry—our team specializes in stepping in when you need us most. Whether it’s a last-minute project
                                or ongoing support, we provide the extra hand you need to stay on track and deliver exceptional results.</p>
                            <p className='text-xl leading-normal text-wrap pTag '>Contact us today to discuss how we can help lift your projects higher.</p>
                        </div>
                    </div>
                </div>


            </div>
        </>
    )
}
export default ProjectSupport;